<template>
  <div class="basket">
    <!-- Header -->
    <div class="alert alert-info my-2 basket-header">Koszyk</div>

    <!-- Basket -->
    <div v-for="b in basket.baskets" class="basket-group">
      <div class="basket-address-header">
        <div>
          Adres dostawy:
          <span
            v-if="b.address"
            class="basket-address-info"
          >{{ b.address.city }}, {{ b.address.street }}</span>
        </div>
      </div>

      <div class="basket-title">
        <div>zdjęcie</div>
        <div v-if="mpkEnable">nazwa</div>
        <div v-else>nazwa</div>
        <div v-if="mpkEnable">MPK</div>
        <div class="basket-quantity-header">ilość</div>
        <div>cena netto</div>
        <div>VAT</div>
        <div>cena brutto</div>
        <div>akcje</div>
      </div>

      <div v-for="position in b.positions" class="basket-position">
        <!-- <div class="col basket-mobile-names">zdjęcie</div> -->
        <div class="basket-photo">
          <img :src="position.photo_url" class="img-fluid" />
        </div>

        <!-- <div class="col basket-mobile-names">nazwa</div> -->
        <div v-if="mpkEnable" class="basket-name">
          <router-link :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}">
            <span>{{position.name}}</span>
          </router-link>
          <!-- <div class="col basket-mobile-names">komentarz</div> -->
          <div class="basket-description">
            <textarea
              cols="10"
              placeholder="Dodaj komentarz ..."
              rows="1"
              v-model="position.description"
              @change="modify(position)"
              class="form-control"
            ></textarea>
          </div>
        </div>
        <div v-else class="basket-name">
          <router-link :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}">
            <span>{{position.name}}</span>
          </router-link>
          <!-- <div class="col basket-mobile-names">komentarz</div> -->
          <div class="basket-description">
            <textarea
              cols="10"
              placeholder="Dodaj komentarz ..."
              rows="1"
              v-model="position.description"
              @change="modify(position)"
              class="form-control"
            ></textarea>
          </div>
        </div>

        <!-- <div class="col basket-mobile-names">adres dostawy</div> -->
        <!-- <div class="col-lg-2 basket-address">
          <select v-model="position.address_id" @change="modify(position)"  class="form-control">
            <option v-for="address in user.addresses" :value="address.id">{{ address.city }}, {{ address.street }}</option>
          </select>
        </div>-->

        <!-- <div class="col basket-mobile-names">mpk</div> -->
        <div v-if="mpkEnable" class="basket-mpk">
          <select v-model="position.mpk_id" @change="modify(position)" class="form-control">
            <option v-for="mpk in company.mpks" :value="mpk.mpk.id">{{mpk.mpk.name}}</option>
          </select>
        </div>

        <!-- <div class="col basket-mobile-names">ilość</div> -->
        <div class="basket-quantity">
          <div class="quantity-input">
            <div class="pull-right">
              <span class="unit-name">{{position.unit_name}}</span>
            </div>
            <input
              type="text"
              class="form-control"
              :value="position.cart_quantity"
              @keyup="verifyQuantity($event, position)"
            />

            <!--
            <div class="input-group-prepend" @click="subQuantity(position)">
              <span class="input-group-text" id="basic-addon1"><minus-icon></minus-icon></span>
            </div>
            -->

            <!-- <div class="col basket-mobile-names">akcje</div> -->
            <!--
            <div class="input-group-append" @click="addQuantity(position)">
              <span class="input-group-text"><plus-icon></plus-icon></span>
            </div>
            -->
          </div>
        </div>

        <!-- <div class="col basket-mobile-names">cena netto</div> -->
        <div
          class="basket-net price"
        >{{priceToString(position.price_net * position.cart_quantity, currency().currency.symbol)}}</div>
        <!-- <div class="col basket-mobile-names">VAT</div> -->
        <div
          class="basket-tax price"
        >{{priceToString(position.price_tax * position.cart_quantity, currency().currency.symbol)}}</div>
        <!-- <div class="col basket-mobile-names">brutto</div> -->
        <div
          class="basket-gross price"
        >{{priceToString(position.price_gross * position.cart_quantity, currency().currency.symbol)}}</div>

        <div class>
          <delete-icon class="basket-action" title="Usuń" @click.native="remove(position)" />
        </div>

        <div v-if="position.range" class="basket-gratis-info">
          <div
            v-if="position.cart_quantity < position.range.min_quantity"
            class="alert alert-info mb-0"
          >
            <img
              src="./../../../assets/icons/info.svg"
              alt="Info Icon"
              class="basket-gratis-info-icon mr-1"
            />
            Kup jeszcze {{quantityToGratis(position.range.min_quantity, position.cart_quantity)}}
            <!-- <span>{{quantityToGratisLabel(position.range.min_quantity, position.cart_quantity)}}</span> -->
            <span
              v-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) === 1"
            >sztukę</span>
            <span
              v-else-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) >= 2 && quantityToGratis(position.range.min_quantity, position.cart_quantity) <= 4"
            >sztuki</span>
            <span v-else>sztuk</span>
            tego produktu, a otrzymasz
            <span
              class="basket-gratis-product"
            >{{ position.range.product_name }}</span>
          </div>
          <div v-else class="alert alert-success mb-0">
            Otrzymujesz
            <span class="basket-gratis-product">{{ position.range.product_name }}!</span>
          </div>
        </div>
      </div>

      <div class="basket-footer">
        <div class="total right">Razem:</div>
        <div class="price">{{priceToString(b.price_net, currency().currency.symbol)}}</div>
        <div class="price">{{priceToString(b.price_tax, currency().currency.symbol)}}</div>
        <div class="price">{{priceToString(b.price_gross, currency().currency.symbol)}}</div>
      </div>
    </div>

    <div v-if="basket.mpk_summary_list.length > 0 && clientLimit >0" class="basket-group">
      <div class="col-12">Limity konsumencki</div>
      <div class="row">
        <div class="col-10 total right">Limit</div>
        <div class="col-2 price">{{priceToString(clientLimit, currency().currency.symbol)}}</div>
      </div>

      <div v-if="basket.mpk_summary_list.length > 0" class="col-12">Limity budżetów</div>
      <div
        v-if="basket.mpk_summary_list.length > 0"
        v-for="mpk in basket.mpk_summary_list"
        class="row mpk-summary"
      >
        <div class="col-10 total right">{{mpk.name}}</div>
        <div class="col-2 price">{{priceToString(mpk.limit, currency().currency.symbol)}}</div>
      </div>
    </div>

    <div class="row order-header">
      <div class="col-12">
        <button
          type="button"
          class="btn btn-info pull-right"
          @click="orderForm"
        >Przejdź do zamówienia</button>
      </div>
    </div>
  </div>
</template>


<script>
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import SubIcon from "vue-material-design-icons/minus.vue";
import PlusIcon from "vue-material-design-icons/plus.vue";
import { mapState, mapGetters } from "vuex";
import MinusIcon from "vue-material-design-icons/minus.vue";
import CalculatePrice from "./../../products/src/product/CalculatePrice";

export default {
  components: {
    MinusIcon,
    PlusIcon,
    DeleteIcon
  },

  computed: {
    ...mapState({
      basket: state => state.basket.basket,
      user: state => state.user,
      company: state => state.company,
      mpkEnable: state =>
        state.shop.settings.find(s => s.name == "B2B_MPK_ENABLED")
          ? state.shop.settings.find(s => s.name == "B2B_MPK_ENABLED")
          : 0,
      shop: state => state.shop.settings,
      demo: state => state.demo.enabled
    }),
    ...mapGetters({
      currency: "company/selectedCurrency",
      clientLimit: "company/clientLimit"
    })
  },
  data() {
    return {
      units: { single: [], decimals: [] },
      purchaseOverbookedProducts: false
    };
  },
  methods: {
    ...CalculatePrice(),

    quantityToGratis(range, basket) {
      return range - basket;
    },

    subQuantity(position) {
      if (position.cart_quantity > 0) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity--;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity - 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity--;
        }
        this.modify(position);
      }
    },

    addQuantity(position) {
      if (position.cart_quantity < position.quantity) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity++;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity + 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity++;
        }
        this.modify(position);
      }
    },

    verifyQuantity(ev, position) {
      let keyValue = ev.target.value;
      setTimeout(() => {
        if (keyValue == ev.target.value) {
          let val = parseFloat(keyValue.replace(",", "."));
          val = val > 0 ? parseFloat(ev.target.value.replace(",", ".")) : 1;
          if (this.units.single.indexOf(position.unit_name)) {
            val = Math.ceil(val);
          }
          if (val > position.quantity && !this.purchaseOverbookedProducts) {
            val = position.quantity;
          }
          position.cart_quantity = val;
          this.modify(position);
        }
      }, 1500);
    },

    selectAddressForAll() {
      for (let i = 0; i < this.basket.baskets.length; i++) {
        this.basket.baskets[i].address = this.user.addresses[0];
        for (let k = 0; k < this.basket.baskets[i].positions.length; k++) {
          this.basket.baskets[i].positions[
            k
          ].address_id = this.user.addresses[0].id;
          this.$store.dispatch(
            "basket/modifyPosition",
            this.basket.baskets[i].positions[k]
          );
        }
      }
    },

    remove(position) {
      this.$store.dispatch("basket/removePosition", position);
    },

    modify(position) {
      this.$store.dispatch("basket/modifyPosition", position);
    },

    orderForm() {
      this.$router.replace({ name: "orderForm" });
    }
  },

  beforeMount() {
    console.log("basket-before");
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.demo) {
      this.units = this.$config.get("basket.units");
      this.$store.dispatch("user/getAddresses");
      this.$store.dispatch("basket/data");
      this.$store.dispatch("company/mpks");
      let b2bOverbooking = this.shop.find(s => s.name == "B2B_OVERBOOKING");
      this.purchaseOverbookedProducts =
        b2bOverbooking && b2bOverbooking.value == 1;
    }
    this.selectAddressForAll();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/basket/src/Basket.vue